import React, { useState, useEffect } from 'react';
import { Button, Tooltip } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faChartScatter,
    faCrosshairsSimple,
    faBalanceScale,
    faChevronsRight,
    faChevronsLeft,
    faRankingStar
} from '@fortawesome/pro-light-svg-icons';
import { useTranslation } from 'react-i18next';

import './ScreenNavigation.sass';

interface ScreenNavigationProps {
    currentScreen: string | null;
    onScreenClick: (screen: string) => void;
    isNavigationEnabled: boolean;
}

export const ScreenNavigation: React.FC<ScreenNavigationProps> = ({
    currentScreen,
    onScreenClick,
    isNavigationEnabled
}) => {
    const { t } = useTranslation();
    const [isEnabled, setIsEnabled] = useState(false);

    useEffect(() => {
        if (isNavigationEnabled) setIsEnabled(true);

        setIsEnabled(isNavigationEnabled);
        if (isNavigationEnabled) setTimeout(() => {
            //setIsEnabled(false);
        }, 3000);
    }, [isNavigationEnabled]);

    const screens = [
        {
            id: 'radar',
            icon: faCrosshairsSimple,
            tooltip: t('pages.navigator.title')
        },
        {
            id: 'indicators',
            icon: faBalanceScale,
            tooltip: t('pages.indicators.title')
        },
        {
            id: 'risks',
            icon: faChartScatter,
            tooltip: t('pages.risks.title')
        },
        {
            id: 'synthesis',
            icon: faRankingStar,
            tooltip: t('pages.scenarios.tabs.alt_title')
        }

    ];

    return (
        <div className={`screen-navigation ${!isNavigationEnabled ? 'disabled' : ''}`}>
            <div className={`arrow-container ${isNavigationEnabled && isEnabled ? 'disappearing' : ''}`}>
                {isEnabled && <>
                    <div className="arrow-left">
                        <FontAwesomeIcon icon={faChevronsRight} />
                    </div>
                    <div className="arrow-right">
                        <FontAwesomeIcon icon={faChevronsLeft} />
                    </div>
                </>}
            </div>

            {screens.map((screen) => (
                <Tooltip key={screen.id} title={screen.tooltip}>
                    <Button
                        type={currentScreen === screen.id ? 'primary' : 'default'}
                        icon={<FontAwesomeIcon icon={screen.icon} />}
                        onClick={() => isNavigationEnabled && onScreenClick(screen.id)}
                        disabled={!isNavigationEnabled}
                    />
                </Tooltip>
            ))}
        </div>
    );
}; 